import { render, staticRenderFns } from "./diffInput.vue?vue&type=template&id=5db15ea6"
import script from "./diffInput.vue?vue&type=script&lang=js"
export * from "./diffInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports